import React from "react";
import http from "../modules/api";

import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

import TextInput from "../modules/common/TextInput";
import SelectBoxV2 from "../modules/common/SelectBoxV2";
import Button from "../modules/common/Button";

import SaveDialogV2 from "../modules/dialogs/SaveDialogV2";
import WarningDialog from "../modules/dialogs/WarningDialog";
import TitleContentDialogV2 from "../modules/dialogs/TitleContentDialogV2";
import RoboMDAICopywriterModal from "./component/RoboMDAICopywriterModal";

const LANGUAGE_OPTIONS = [
  { text: "전체 언어", value: "" },
  { text: "한국어", value: "KO" },
  { text: "영어", value: "EN" },
  { text: "일본어", value: "JA" },
];

const LEARNING_OPTIONS = [
  { text: "전체 학습 설정", value: "" },
  { text: "학습 사용", value: "Y" },
  { text: "학습 미사용", value: "N" },
];

const languageList = [
  { name: "한국어", code: "ko" }, { name: "영어", code: "en" },
  { name: "독일어", code: "de" }, { name: "중국어(간체)", code: "zh-cn" },
  { name: "중국어(번체)", code: "zh-tw" }, { name: "일본어", code: "ja" },
  { name: "베트남어", code: "vi" }, { name: "프랑스어", code: "fr" },
  { name: "스페인어", code: "es" }, { name: "힌디어", code: "hi" },
  { name: "아랍어", code: "ar" }, { name: "벵골어", code: "bn" },
  { name: "러시아어", code: "ru" }, { name: "포르투갈어", code: "pt" }
];

const COPYWRITER_SELECTED_CONTENT_STORAGE_KEY = "instagram_copywriter_selected_content";
const COPYWRITER_SELECTED_CONTENT_APPLY_PARAM = "apply_copywriter_content";

const CopywriterRunIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M15 6V9H19" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19 11.0938V8.75L14.8519 5H5V20H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 8.70312H12" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 12.3984H13" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 16.1016H10" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 20L14 17.8571M18 20L17 17.8571M14 17.8571L15.5 14L17 17.8571M14 17.8571H17M20 14V20" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default class InstagramCopywriterSettingList extends React.Component {
  static defaultProps = {
    pageSizes: [
      { value: 20, text: "20개" },
      { value: 50, text: "50개" },
      { value: 100, text: "100개" },
    ],
  };

  constructor(props) {
    super(props);
    this.state = {
      rows: Array.isArray(props.rows) && props.rows.length ? props.rows : [],

      q: "",
      language_code: "",
      is_data_learning_on: "",
      startDate: null,
      endDate: null,

      page: 1,
      rowsPage: 1,
      pageSize: 20,
      sortKey: "icp.reg_date",
      sortDir: "desc",
      total: 0,
      dateType: "all",
      tutorialListLoaded: false,

      deletingPresetSeq: null,
      duplicatingPresetSeq: null,

      save_dialog_show_state: false,
      save_dialog_content: "",
      save_dialog_button_list: [],

      warning_dialog_show_state: false,
      warning_dialog_content: "",
      warning_dialog_button_list: [],
      warning_dialog_width_auto: false,

      title_content_dialog_show_state: false,
      title_content_dialog_title: "",
      title_content_dialog_content: "",
      title_content_dialog_button_list: [],

      copywriter_run_modal_show_state: false,
      copywriter_run_preset_seq: null,
    };
  }

  componentDidMount() {
    this.fetchListFromApi();

    const tutorialPopup = new URLSearchParams(window.location.search).get("tutorial_popup");
    if (tutorialPopup === "POPUP_COPYWRITER_RUN") {
      this.setState({
        copywriter_run_modal_show_state: true,
        copywriter_run_preset_seq: null,
      });
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete("tutorial_popup");
      window.history.replaceState({}, document.title, `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
    }
  }

  formatDate = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  fetchListFromApi = async () => {
    const tutorialRequestSeq = (this.tutorialListRequestSeq || 0) + 1;
    this.tutorialListRequestSeq = tutorialRequestSeq;
    this.setState({ tutorialListLoaded: false });

    const {
      q,
      language_code,
      is_data_learning_on,
      startDate,
      endDate,
      page,
      pageSize,
      sortKey,
      sortDir,
    } = this.state;

    try {
      const resp = await http.get("/rest/shop/instagram/copywriter/preset/list", {
        params: {
          q: q || "",
          language_code: language_code || "",
          is_data_learning_on: is_data_learning_on ? (is_data_learning_on == "Y" ? "1" : "0") : "",
          sort_by: sortKey || "icp.reg_date",
          sort_dir: (sortDir || "desc").toUpperCase(),
          start: (page - 1) * pageSize,
          row_cnt: pageSize,
          start_date: startDate ? this.formatDate(startDate) : null,
          end_date: endDate ? this.formatDate(endDate) : null,
        },
      });

      const { total, list } = resp.data.result || resp.data;

      const rows = (list || []).map((m) => {
        return {
          id: String(m.preset_seq),
          preset_title: m.preset_title || "-",
          industry: m.industry || "-",
          target: m.target || "-",
          language_code: m.language_code || "-",
          objective: m.objective || "-",
          extra_prompt: m.extra_prompt || "",
          is_data_learning_on: m.is_data_learning_on || "N",
          learning_data_type: m.learning_data_type || "-",
          call_to_action_position: m.call_to_action_position || "-",
          call_to_action_text: m.call_to_action_text || "-",
          use_basic_voice: m.use_basic_voice,
          use_myfeed_voice: m.use_myfeed_voice,
          use_custom_voice: m.use_custom_voice,
          basic_voice_index: m.basic_voice_index,
          custom_voice_index: m.custom_voice_index,
          default_yn: m.default_yn || "N",
          reg_date: m.reg_date,
          reg_date_format: m.reg_date_format || m.reg_date || "-",
        };
      });

      this.setState({
        rows,
        rowsPage: page,
        total: total || 0,
      });
    } catch (err) {
      console.error("카피라이터 프리셋 목록 조회 실패", err);
    } finally {
      if (this.tutorialListRequestSeq === tutorialRequestSeq) {
        this.setState({ tutorialListLoaded: true });
      }
    }
  };

  fmtNumber(n) {
    return n === null || n === undefined ? "-" : Number(n).toLocaleString();
  }

  changeSort = (key) => {
    this.setState(
      (prev) =>
        prev.sortKey === key
          ? { sortDir: prev.sortDir === "asc" ? "desc" : "asc" }
          : { sortKey: key, sortDir: "desc" },
      this.fetchListFromApi
    );
  };

  handleInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, page: 1 });
  };

  handleSelectBox = (name) => (text, value) => {
    this.handleInput({ target: { name, value } });
  };

  setQuickRange = (type) => {
    const today = new Date();

    if (type === "today") {
      this.setState({ startDate: today, endDate: today, page: 1, dateType: type }, this.fetchListFromApi);
    } else if (type === "week") {
      const day = today.getDay();
      const diff = day === 0 ? 6 : day - 1;
      const monday = new Date(today);
      monday.setDate(today.getDate() - diff);
      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);
      this.setState({ startDate: monday, endDate: sunday, page: 1, dateType: type }, this.fetchListFromApi);
    } else if (type === "month") {
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.setState({ startDate: first, endDate: last, page: 1, dateType: type }, this.fetchListFromApi);
    } else {
      this.setState({ startDate: null, endDate: null, page: 1, dateType: type }, this.fetchListFromApi);
    }
  };

  goPage = (p) => {
    this.setState({ page: p }, this.fetchListFromApi);
  };

  changePageSize = (e) => {
    this.setState({ pageSize: Number(e.target.value), page: 1 }, this.fetchListFromApi);
  };

  goCreatePage = () => {
    if (window.location.pathname == "/shop/genAi/CopywriterSettingList") {
      window.location.href = "/shop/genAi/CopywriterSetting";
    }
    else {
      window.location.href = "/shop/instagram/InstagramCopywriterSetting";
    }
  };

  goDetailPage = (presetSeq) => {
    if (window.location.pathname == "/shop/genAi/CopywriterSettingList") {
      window.location.href = `/shop/genAi/CopywriterSetting?preset_seq=${presetSeq}`;
    } else {
      window.location.href = `/shop/instagram/InstagramCopywriterSetting?preset_seq=${presetSeq}`;
    }
  };

  openCopywriterRunModal = (e, presetSeq = null) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({
      copywriter_run_modal_show_state: true,
      copywriter_run_preset_seq: presetSeq ? String(presetSeq) : null,
    });
  };

  closeCopywriterRunModal = () => {
    this.setState({
      copywriter_run_modal_show_state: false,
      copywriter_run_preset_seq: null,
    });
  };

  handleCopywriterContentRegister = async (
    mergedCaption,
    selectedRecommendations = [],
    copywriterContext = {}
  ) => {
    const nextCaption = String(mergedCaption || "").trim();

    if (!nextCaption) {
      this.showWarningDialog("콘텐츠에 사용할 문구를 하나 이상 선택해주세요.");
      return false;
    }

    const recommendationHistorySeq = (selectedRecommendations || [])
      .map((item) => item?.copywriter_history_seq)
      .find(Boolean);

    const payload = {
      caption: nextCaption,
      content: nextCaption,
      selectedText: nextCaption,
      mergedCaption: nextCaption,
      copywriter_preset_seq: copywriterContext.copywriter_preset_seq || null,
      copywriter_preset_title: copywriterContext.copywriter_preset_title || null,
      copywriter_history_seq:
        copywriterContext.copywriter_history_seq ||
        recommendationHistorySeq ||
        null,
      selected_recommendations: selectedRecommendations || [],
    };

    try {
      sessionStorage.setItem(
        COPYWRITER_SELECTED_CONTENT_STORAGE_KEY,
        JSON.stringify(payload)
      );
    } catch (error) {
      console.error("AI 카피라이터 선택 문구 저장 실패", error);
      this.showWarningDialog("선택한 문구를 콘텐츠 등록 화면으로 전달하지 못했습니다.<br/>잠시 후 다시 시도해주세요.");
      return false;
    }

    window.location.href = `/shop/instagram/InstagramCreatePost?${COPYWRITER_SELECTED_CONTENT_APPLY_PARAM}=Y`;

    return { applied: true };
  };

  closeWarningDialog = () => {
    this.setState({ warning_dialog_show_state: false, warning_dialog_width_auto: false });
  };

  showWarningDialog = (content) => {
    this.setState({
      warning_dialog_show_state: true,
      warning_dialog_content: content,
      warning_dialog_button_list: [{
        title: "확인",
        type: "1",
        event_method: this.closeWarningDialog,
      }],
      warning_dialog_width_auto: true
    });
  };

  closeDeleteConfirmDialog = () => {
    this.setState({
      title_content_dialog_show_state: false,
      title_content_dialog_title: "",
      title_content_dialog_content: "",
      title_content_dialog_button_list: [],
    });
  };

  openDeleteConfirmDialog = (e, row) => {
    e.stopPropagation();

    const isDefault = String(row.default_yn || "N").toUpperCase() === "Y";
    const content = 
    // isDefault
    //   ? "현재 기본으로 설정된 AI 카피라이터입니다.<br/>삭제하면 기본 설정이 해제되고 베이직 AI가 사용됩니다.<br/>삭제한 설정은 복구할 수 없습니다."
    //   : "삭제한 AI 카피라이터 설정은 복구할 수 없습니다.";
    "삭제한 AI 카피라이터 설정은 복구할 수 없습니다.";

    this.setState({
      title_content_dialog_show_state: true,
      title_content_dialog_title: "AI 카피라이터 설정을 삭제하시겠습니까?",
      title_content_dialog_content: content,
      title_content_dialog_button_list: [
        {
          title: "삭제",
          type: "1",
          event_method: () => {
            this.closeDeleteConfirmDialog();
            this.deletePreset(row);
          },
        },
        {
          title: "취소",
          type: "0",
          event_method: this.closeDeleteConfirmDialog,
        },
      ],
    });
  };

  deletePreset = async (row) => {
    if (!row?.id || this.state.deletingPresetSeq) return;

    this.setState({
      deletingPresetSeq: row.id,
      save_dialog_show_state: true,
      save_dialog_content: "삭제 중입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn: "N" }],
    });

    try {
      const response = await http.delete(
        `/rest/shop/instagram/copywriter/preset/${encodeURIComponent(row.id)}`
      );
      const result = response?.data || {};

      if (result.status === "used") {
        this.setState({
          deletingPresetSeq: null,
          save_dialog_show_state: false,
          save_dialog_content: "",
          save_dialog_button_list: [],
        }, () => {
          this.showWarningDialog(
            "자동화 설정에 사용 중인 AI 카피라이터는 삭제할 수 없습니다.<br/>자동화 설정에서 다른 카피라이터로 변경 후 다시 시도해주세요."
          );
        });
        return;
      }

      if (result.status !== "success") {
        throw new Error(result.message || "삭제에 실패했습니다.");
      }

      const nextPage = this.state.rows.length === 1 && this.state.page > 1
        ? this.state.page - 1
        : this.state.page;

      await new Promise((resolve) => this.setState({ page: nextPage }, resolve));
      await this.fetchListFromApi();

      this.setState({
        deletingPresetSeq: null,
        save_dialog_show_state: true,
        save_dialog_content: "삭제 완료되었습니다.",
        save_dialog_button_list: [{
          title: "확인",
          type: "1",
          event_method: () => this.setState({ save_dialog_show_state: false }),
        }],
      });
    } catch (error) {
      console.error("AI 카피라이터 설정 삭제 실패", error);
      this.setState({
        deletingPresetSeq: null,
        save_dialog_show_state: false,
        save_dialog_content: "",
        save_dialog_button_list: [],
      }, () => {
        this.showWarningDialog(error?.message || "삭제 중 오류가 발생했습니다.");
      });
    }
  };

  duplicatePreset = async (e, row) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!row?.id || this.state.duplicatingPresetSeq || this.state.deletingPresetSeq) return;

    this.setState({
      duplicatingPresetSeq: row.id,
      save_dialog_show_state: true,
      save_dialog_content: "복제 중입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn: "N" }],
    });

    try {
      const response = await http.post(
        `/rest/shop/instagram/copywriter/preset/${encodeURIComponent(row.id)}/duplicate`
      );
      const result = response?.data || {};
      if (result.status !== "success" && result.result !== "success") {
        throw new Error(result.message || "복제에 실패했습니다.");
      }

      await new Promise((resolve) => this.setState({ page: 1 }, resolve));
      await this.fetchListFromApi();
      this.setState({
        duplicatingPresetSeq: null,
        save_dialog_show_state: true,
        save_dialog_content: result.message || "복제 완료되었습니다.",
        save_dialog_button_list: [{
          title: "확인",
          type: "1",
          event_method: () => this.setState({ save_dialog_show_state: false }),
        }],
      });
    } catch (error) {
      console.error("AI 카피라이터 설정 복제 실패", error);
      const message = error?.response?.data?.message || error?.message || "복제 중 오류가 발생했습니다.";
      this.setState({
        duplicatingPresetSeq: null,
        save_dialog_show_state: false,
        save_dialog_content: "",
        save_dialog_button_list: [],
      }, () => {
        this.showWarningDialog(message);
      });
    }
  };

  getLanguageName = (code) => {
    if (!code) return "-";
    return languageList.find((lang) => String(lang.code).toLowerCase() === String(code).toLowerCase())?.name || code;
  };

  getCtaPositionText = (position) => {
    if (!position || position === "-") return "-";
    if (position == "top") return "상단 고정 추가";
    if (position == "bottom") return "하단 고정 추가";
    return "-";
  };

  getRowNo = (index) => {
    const { total, rowsPage, pageSize } = this.state;
    if (!total) return index + 1;
    return total - ((rowsPage - 1) * pageSize + index);
  };

  renderSortHead(label, key, align = "left", width = "auto") {
    const { sortKey, sortDir } = this.state;
    const isActive = sortKey === key;

    return (
      <th
        className={align === "left" ? "text-left" : ""}
        onClick={() => this.changeSort(key)}
        style={{ width, cursor: "pointer", textAlign: align }}
        title="정렬"
      >
        {label}
        {isActive ? <span className="sort-mark">{sortDir === "asc" ? " ▲" : " ▼"}</span> : null}
      </th>
    );
  }

  renderVoiceBadges = (row) => {
    const items = [];

    if (row.use_basic_voice == 1 || row.use_basic_voice === true || row.use_basic_voice === "Y") {
      items.push(<span key="basic" className="badge badge-auto">AI 브랜드 보이스</span>);
    }

    if (row.use_myfeed_voice == 1 || row.use_myfeed_voice === true || row.use_myfeed_voice === "Y") {
      items.push(<span key="myfeed" className="badge badge-scheduled">내 기존 피드</span>);
    }

    if (row.use_custom_voice == 1 || row.use_custom_voice === true || row.use_custom_voice === "Y") {
      items.push(<span key="custom" className="badge badge-manual">커스텀 뱅크</span>);
    }

    if (items.length === 0) {
      return <span className="badge badge-failed">선택 없음</span>;
    }

    return items;
  };

  renderLearningBadge = (value) => {
    if (value === "Y" || value === 1 || value === true) {
      return <span className="badge badge-auto">학습 사용</span>;
    }
    return <span className="badge badge-manual">학습 미사용</span>;
  };

  render() {
    const { pageSizes } = this.props;
    const {
      q,
      language_code,
      is_data_learning_on,
      startDate,
      endDate,
      page,
      pageSize,
      dateType,
      rows,
      total,
      tutorialListLoaded,
    } = this.state;

    const totalPages = Math.max(1, Math.ceil((total || 0) / pageSize));

    return (
      <>
        <style>{`
          .instagram-copywriter-setting-page,
          .instagram-copywriter-setting-page * {
            box-sizing: border-box;
            font-family: 'Noto Sans KR', sans-serif;
            letter-spacing: -0.3px;
          }

          #page-wrapper {
            padding: 72px 0 0 220px;
            max-width: 100%;
          }

          .instagram-copywriter-setting-page {
            --primary-mint: #00e2e6;
            --primary-dark: #00bfc2;
            --navy-dark: #0A1A2F;
            --bg-body: #f4f7f9;
            --bg-canvas: #ffffff;
            --text-primary: #111827;
            --text-secondary: #4b5563;
            --text-muted: #9ca3af;
            --border-color: #e5e7eb;
            --border-light: #f3f4f6;

            display: flex;
            width: 100%;
            min-height: 100vh;
            background: var(--bg-body);
            color: var(--text-primary);
            overflow-x: hidden;
          }

          .instagram-copywriter-setting-page .select_area {
            border: 1px solid var(--border-color) !important;
          }
          .instagram-copywriter-setting-page button,
          .instagram-copywriter-setting-page input,
          .instagram-copywriter-setting-page select {
            font-family: inherit;
          }

          .instagram-copywriter-setting-page .fa {
            font-family: "Font Awesome 6 Free", "Font Awesome 5 Free";
            font-weight: 900;
          }

          .instagram-copywriter-setting-page .main-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            min-width: 0;
            width: 100%;
          }

          .instagram-copywriter-setting-page .top-header {
            height: 50px;
            background-color: var(--bg-canvas);
            border-bottom: 1px solid var(--border-color);
            display: flex;
            align-items: center;
            padding: 0 24px;
            font-size: 13px;
            font-weight: 600;
            color: var(--text-primary);
            flex-shrink: 0;
          }

          .instagram-copywriter-setting-page .top-header span {
            color: var(--text-muted);
            font-weight: 400;
            margin-right: 8px;
          }

          .instagram-copywriter-setting-page .content-inner {
            padding: 32px 40px;
            max-width: 1600px;
            width: 100%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            gap: 32px;
            flex: 1;
            min-height: calc(100vh - 72px);
          }

          .instagram-copywriter-setting-page .center-hero {
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 12px;
            margin-bottom: 8px;
          }

          .instagram-copywriter-setting-page .center-hero h2 {
            font-size: 24px;
            font-weight: 700;
            color: var(--navy-dark);
            margin: 0;
          }

          .instagram-copywriter-setting-page .center-hero p {
            font-size: 14px;
            color: var(--text-secondary);
            margin: 0 0 8px 0;
            word-break: keep-all;
          }

          .instagram-copywriter-setting-page .hero-button-wrap {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            flex-wrap: wrap;
          }

          .instagram-copywriter-setting-page .hero-button-wrap .common_button {
            border-radius: 8px !important;
            font-weight: 700 !important;
            box-shadow: 0 4px 12px rgba(0, 226, 230, 0.2);
            transition: all 0.2s !important;
          }

          .instagram-copywriter-setting-page .copywriter-run-btn {
            align-items: center;
            background: #fff;
            border: 1px solid #333;
            border-radius: 8px;
            color: #333;
            cursor: pointer;
            display: inline-flex;
            font-size: 15px;
            font-weight: 800;
            gap: 8px;
            justify-content: center;
            height: 48px;
            min-width: 190px;
            padding: 0 18px;
            transition: all 0.2s ease;
            white-space: nowrap;
          }

          .instagram-copywriter-setting-page .copywriter-run-btn svg {
            width: 24px;
            height: 24px;
            flex: 0 0 24px;
          }

          .instagram-copywriter-setting-page .copywriter-run-btn:hover:not(:disabled) {
            border-color: var(--primary-mint);
            background: #f0fdfe;
            transform: translateY(-2px);
          }

          .instagram-copywriter-setting-page .common_button.hover_mint:hover {
            background:#00D3E0 !important;
            transform: translateY(-2px)!important;
          }

          .instagram-copywriter-setting-page .common_button.hover_mint::after {
            width: 0px !important;
            height: 0px !important;
          }

          .instagram-copywriter-setting-page .hero-button-icon {
            width: 14px;
            height: 14px;
            filter: brightness(0);
            margin-right: 4px;
            vertical-align: -2px;
          }

          .instagram-copywriter-setting-page .feature-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
            margin-bottom: 8px;
          }

          .instagram-copywriter-setting-page .feature-item {
            background: var(--bg-canvas);
            border: 1px solid var(--border-color);
            padding: 24px;
            border-radius: 12px;
            box-shadow: none;
            display: flex;
            flex-direction: column;
            cursor: default;
          }

          .instagram-copywriter-setting-page .feature-icon {
            width: 44px;
            height: 44px;
            background: rgba(0, 226, 230, 0.1);
            color: var(--primary-dark);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            font-size: 20px;
            margin-bottom: 16px;
          }

          .instagram-copywriter-setting-page .feature-item h4 {
            font-size: 16px;
            font-weight: 700;
            color: var(--navy-dark);
            margin: 0 0 8px;
          }

          .instagram-copywriter-setting-page .feature-item p {
            font-size: 13px;
            color: var(--text-secondary);
            line-height: 1.5;
            word-break: keep-all;
            margin: 0;
          }

          .instagram-copywriter-setting-page .list-section-wrapper {
            background: var(--bg-canvas);
            border: 1px solid var(--border-color);
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(10, 26, 47, 0.02);
            overflow: hidden;
          }

          .instagram-copywriter-setting-page .filter-header {
            padding: 20px;
            border-bottom: 1px solid var(--border-color);
            display: flex;
            flex-direction: column;
            gap: 16px;
          }

          .instagram-copywriter-setting-page .filter-controls-row {
            display: flex;
            gap: 12px;
            flex-wrap: wrap;
            align-items: center;
          }

          .instagram-copywriter-setting-page .filter-input-wrap {
            flex: 1;
            min-width: 200px;
          }

          .instagram-copywriter-setting-page .filter-input-wrap input {
            border: 1px solid var(--border-color) !important;
            border-radius: 6px !important;
            font-size: 13px !important;
            outline: none !important;
            padding: 10px 14px !important;
          }

          .instagram-copywriter-setting-page .filter-input-wrap input:focus {
            border-color: var(--primary-mint) !important;
          }

          .instagram-copywriter-setting-page .filter-select-wrap {
            min-width: 140px;
            flex: 0 0 150px;
          }

          .instagram-copywriter-setting-page .date-range-group {
            display: flex;
            align-items: center;
            gap: 8px;
          }

          .instagram-copywriter-setting-page .filter-date-picker {
            width: 120px;
          }

          .instagram-copywriter-setting-page .filter-date-picker .react-datepicker-wrapper,
          .instagram-copywriter-setting-page .filter-date-picker .react-datepicker__input-container {
            width: 100%;
            margin-bottom: 0 !important;
          }

          .instagram-copywriter-setting-page .date-input {
            padding: 10px 14px;
            border: 1px solid var(--border-color);
            border-radius: 6px;
            font-size: 13px;
            width: 120px;
            height: 36px;
            outline: none;
            text-align: center;
            background: #fff;
          }

          .instagram-copywriter-setting-page .date-input:focus {
            border-color: var(--primary-mint);
          }

          .instagram-copywriter-setting-page .react-datepicker-popper {
            z-index: 1000;
          }

          .instagram-copywriter-setting-page .btn-apply {
            background: #64748b;
            color: #fff;
            border: none;
            padding: 10px 24px;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
            white-space: nowrap;
            height: 36px;
            line-height: 1.4;
          }

          .instagram-copywriter-setting-page .btn-apply:hover {
            background: var(--navy-dark);
          }

          .instagram-copywriter-setting-page .filter-chips-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 12px;
          }

          .instagram-copywriter-setting-page .chip-group {
            display: flex;
            gap: 6px;
            flex-wrap: wrap;
          }

          .instagram-copywriter-setting-page .chip-btn {
            padding: 6px 14px;
            border: 1px solid var(--border-color);
            background: var(--bg-canvas);
            border-radius: 20px;
            font-size: 12px;
            font-weight: 600;
            cursor: pointer;
            color: var(--text-secondary);
            transition: all 0.2s;
          }

          .instagram-copywriter-setting-page .chip-btn.active {
            background: #e2e8f0;
            color: #1e293b;
            border-color: #cbd5e1;
          }

          .instagram-copywriter-setting-page .chip-btn:hover:not(.active) {
            background: var(--border-light);
          }

          .instagram-copywriter-setting-page .total-count {
            font-size: 13px;
            color: var(--text-secondary);
          }

          .instagram-copywriter-setting-page .total-count span {
            font-weight: 700;
            color: var(--navy-dark);
          }

          .instagram-copywriter-setting-page .table-responsive {
            width: 100%;
            overflow-x: auto;
          }

          .instagram-copywriter-setting-page .robo-table {
            width: 100%;
            border-collapse: collapse;
            text-align: center;
            min-width: 1290px;
          }

          .instagram-copywriter-setting-page .robo-table th {
            background: #f8fafc;
            padding: 16px;
            font-size: 13px;
            font-weight: 700;
            color: var(--navy-dark);
            border-bottom: 1px solid var(--border-color);
            white-space: nowrap;
          }

          .instagram-copywriter-setting-page .robo-table td {
            padding: 16px;
            font-size: 13px;
            color: var(--text-secondary);
            border-bottom: 1px solid var(--border-light);
            vertical-align: middle;
          }

          .instagram-copywriter-setting-page .robo-table tr:hover {
            background: #f8fafc;
          }

          .instagram-copywriter-setting-page .copywriter-action-group {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            flex-wrap: nowrap;
          }

          .instagram-copywriter-setting-page .copywriter-table-run-btn,
          .instagram-copywriter-setting-page .copywriter-duplicate-btn,
          .instagram-copywriter-setting-page .copywriter-delete-btn {
            height: 34px;
            align-items: center;
            background: #fff;
            border: 1px solid #333;
            border-radius: 6px;
            color: #333;
            cursor: pointer;
            display: inline-flex;
            font-size: 12px;
            font-weight: 700;
            gap: 5px;
            justify-content: center;
            min-width: 58px;
            padding: 7px;
            transition: all 0.2s ease;
            white-space: nowrap;
          }

          .instagram-copywriter-setting-page .copywriter-table-run-btn svg {
            width: 20px;
            height: 20px;
            flex: 0 0 20px;
          }

          .instagram-copywriter-setting-page .copywriter-table-run-btn:hover:not(:disabled),
          .instagram-copywriter-setting-page .copywriter-duplicate-btn:hover:not(:disabled),
          .instagram-copywriter-setting-page .copywriter-delete-btn:hover:not(:disabled) {
            border-color: var(--primary-mint) !important;
            background: #f0fdfe !important;
          }

          .instagram-copywriter-setting-page .copywriter-table-run-btn:disabled,
          .instagram-copywriter-setting-page .copywriter-duplicate-btn:disabled,
          .instagram-copywriter-setting-page .copywriter-delete-btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          .instagram-copywriter-setting-page .robo-table .text-left {
            text-align: left;
          }

          .instagram-copywriter-setting-page .cell-title {
            font-weight: 600;
            color: var(--text-primary);
          }

          .instagram-copywriter-setting-page .sort-mark {
            // color: var(--primary-dark);
            color: var(--navy-dark);
            font-size: 11px;
          }

          .instagram-copywriter-setting-page .badge-list {
            display: flex;
            flex-wrap: wrap;
            gap: 4px;
            justify-content: center;
          }

          .instagram-copywriter-setting-page .badge {
            display: inline-block;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 11px;
            font-weight: 600;
            white-space: nowrap;
          }

          .instagram-copywriter-setting-page .badge-auto {
            background: #e3f2fd;
            color: #1976d2;
          }

          .instagram-copywriter-setting-page .badge-manual {
            background: #f3e5f5;
            color: #7b1fa2;
          }

          .instagram-copywriter-setting-page .badge-published {
            background: #e8f5e9;
            color: #2e7d32;
          }

          .instagram-copywriter-setting-page .badge-scheduled {
            background: #e3f2fd;
            color: #1976d2;
          }

          .instagram-copywriter-setting-page .badge-draft {
            background: #fff3e0;
            color: #f57c00;
          }

          .instagram-copywriter-setting-page .badge-failed {
            background: #ffebee;
            color: #ed4956;
          }

          .instagram-copywriter-setting-page .info-badge {
            background: #e0f2fe;
            color: #0284c7;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 11px;
            font-weight: 600;
            white-space: nowrap;
          }

          .instagram-copywriter-setting-page .info-badge-purple {
            background: #f3e5f5;
            color: #7b1fa2;
          }

          .instagram-copywriter-setting-page .info-badge-muted {
            background: #f3f4f6;
            color: #6b7280;
          }

          .instagram-copywriter-setting-page .pagination-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px 20px;
            flex-wrap: wrap;
            gap: 16px;
          }

          .instagram-copywriter-setting-page .page-numbers {
            display: flex;
            gap: 4px;
            margin: 0 auto;
          }

          .instagram-copywriter-setting-page .page-numbers button {
            width: 32px;
            height: 32px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border: 1px solid var(--border-color);
            background: var(--bg-canvas);
            color: var(--text-secondary);
            border-radius: 4px;
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          }

          .instagram-copywriter-setting-page .page-numbers button:hover:not(:disabled) {
            background: var(--border-light);
          }

          .instagram-copywriter-setting-page .page-numbers button.active {
            background: var(--navy-dark);
            color: #fff;
            border-color: var(--navy-dark);
            font-weight: 700;
          }

          .instagram-copywriter-setting-page .page-numbers button:disabled {
            opacity: 0.45;
            cursor: not-allowed;
          }

          .instagram-copywriter-setting-page .page-size-selector {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 13px;
            color: var(--text-secondary);
          }

          .instagram-copywriter-setting-page .page-size-selector > span {
            white-space: nowrap;
          }

          .instagram-copywriter-setting-page #pageSizeSelect {
            background-color: white !important;
          }

          @media screen and (max-width: 1024px) {
            .instagram-copywriter-setting-page {
              display: block;
            }

            .instagram-copywriter-setting-page .top-header {
              display: none;
            }

            .instagram-copywriter-setting-page .main-content {
              width: 100%;
            }

            .instagram-copywriter-setting-page .content-inner {
              padding: 24px 16px;
              gap: 24px;
            }

            .instagram-copywriter-setting-page .feature-grid {
              grid-template-columns: repeat(3, 1fr);
              gap: 12px;
            }
          }

          @media screen and (max-width: 800px) {
            .instagram-copywriter-setting-page .center-hero {
              gap: 12px;
              margin-bottom: 8px;
            }

            .instagram-copywriter-setting-page .center-hero h2 {
              font-size: 22px;
            }

            .instagram-copywriter-setting-page .center-hero p {
              font-size: 13px;
              padding: 0 16px;
              word-break: keep-all;
              margin: 0;
            }

            .instagram-copywriter-setting-page .feature-grid {
              grid-template-columns: 1fr;
              gap: 12px;
            }

            .instagram-copywriter-setting-page .list-section-wrapper {
              background: transparent;
              border: none;
              box-shadow: none;
              overflow: visible;
            }

            .instagram-copywriter-setting-page .filter-header {
              background: var(--bg-canvas);
              border: 1px solid var(--border-color);
              border-radius: 12px;
              margin-bottom: 16px;
              box-shadow: 0 2px 8px rgba(10, 26, 47, 0.02);
            }

            .instagram-copywriter-setting-page .filter-controls-row {
              flex-direction: column;
              align-items: stretch;
            }

            .instagram-copywriter-setting-page .filter-input-wrap,
            .instagram-copywriter-setting-page .filter-select-wrap {
              width: 100%;
              min-width: 100%;
              flex: 1 1 auto;
            }

            .instagram-copywriter-setting-page .date-range-group {
              justify-content: space-between;
              width: 100%;
            }

            .instagram-copywriter-setting-page .filter-date-picker {
              flex: 1;
              width: auto;
            }

            .instagram-copywriter-setting-page .date-input {
              width: 100%;
            }

            .instagram-copywriter-setting-page .btn-apply {
              width: 100%;
            }

            .instagram-copywriter-setting-page .filter-chips-row {
              flex-direction: column;
              align-items: flex-start;
              gap: 16px;
            }

            .instagram-copywriter-setting-page .total-count {
              align-self: flex-end;
            }

            .instagram-copywriter-setting-page .table-responsive {
              overflow-x: visible;
            }

            .instagram-copywriter-setting-page .robo-table,
            .instagram-copywriter-setting-page .robo-table tbody {
              display: block;
              width: 100%;
              min-width: 100%;
            }

            .instagram-copywriter-setting-page .robo-table thead {
              display: none;
            }

            .instagram-copywriter-setting-page .robo-table tr {
              display: flex;
              flex-direction: column;
              background: var(--bg-canvas);
              border: 1px solid var(--border-color);
              border-radius: 12px;
              padding: 20px;
              margin-bottom: 16px;
              box-shadow: 0 2px 8px rgba(10, 26, 47, 0.03);
              gap: 10px;
            }

            .instagram-copywriter-setting-page .robo-table tr:hover {
              background: var(--bg-canvas);
            }

            .instagram-copywriter-setting-page .robo-table td {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              padding: 0;
              border: none;
              font-size: 13px;
              text-align: right;
              width: 100%;
              gap: 16px;
            }

            .instagram-copywriter-setting-page .robo-table td::before {
              content: attr(data-label);
              font-weight: 600;
              color: var(--text-muted);
              width: 100px;
              flex-shrink: 0;
              text-align: left;
              font-size: 12px;
            }

            .instagram-copywriter-setting-page .robo-table td:nth-child(2) {
              display: block;
              text-align: left;
              font-size: 16px;
              font-weight: 700;
              color: var(--navy-dark);
              border-bottom: 1px solid var(--border-light);
              padding-bottom: 12px;
              margin-bottom: 4px;
            }

            .instagram-copywriter-setting-page .robo-table td:nth-child(2)::before {
              display: none;
            }

            .instagram-copywriter-setting-page .robo-table .badge-list {
              justify-content: flex-end;
            }

            .instagram-copywriter-setting-page .copywriter-action-group {
              justify-content: flex-end;
              flex-wrap: wrap;
            }

            .instagram-copywriter-setting-page .empty-row td {
              display: block;
              text-align: center;
            }

            .instagram-copywriter-setting-page .empty-row td::before {
              display: none;
            }

            .instagram-copywriter-setting-page .pagination-container {
              flex-direction: row;
              justify-content: center;
              gap: 16px;
              padding: 20px 0;
            }

            .instagram-copywriter-setting-page .page-numbers {
              margin: 0;
            }

            .instagram-copywriter-setting-page .page-size-selector {
              display: flex;
              justify-content: center;
              // width: 100%;
            }
          }
        `}</style>

        <div
          id="page-wrapper"
          className="instagram-copywriter-list instagram-copywriter-setting-page"
          data-instagram-tutorial-ready={tutorialListLoaded ? "true" : "false"}
        >
          <main className="main-content">
            <header className="top-header">
              <span>AI도구 &gt;</span> AI카피라이터
            </header>

            <div className="content-inner">
              <section className="center-hero">
                <h2>AI 카피라이터 설정 목록</h2>
                <p>SNS 문구 생성 명령을 저장하고 콘텐츠 제작과 자동화에 활용하세요.</p>
                <div className="hero-button-wrap">
                  <button
                    type="button"
                    className="copywriter-run-btn"
                    onClick={(e) => this.openCopywriterRunModal(e)}
                  >
                    <CopywriterRunIcon />
                    AI 카피라이터 실행
                  </button>
                  <Button
                    type={"hover_mint"}
                    width={"190px"}
                    height={"48px"}
                    fontSize={"15px"}
                    onClick={this.goCreatePage}
                  >
                    <img className="hero-button-icon" src="https://robomd.io/static/media/default_plus.466aee97.svg" alt="+" />
                    새 카피라이터 설정
                  </Button>
                </div>
              </section>

              {/* <section className="feature-intro">
                <div className="feature-grid">
                  <div className="feature-item">
                    <div className="feature-icon"><i className="fa fa-solid fa-graduation-cap" /></div>
                    <h4>브랜드 아이덴티티 학습</h4>
                    <p>AI가 기존 피드와 브랜드 보이스를 학습하여 이질감 없이 우리 브랜드만의 맞춤형 텍스트를 생성합니다.</p>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon"><i className="fa fa-solid fa-bullseye" /></div>
                    <h4>정교한 타겟팅 맞춤 설정</h4>
                    <p>업종과 주 고객층(타겟)에 맞춰 가장 반응률이 높은 최적의 어투와 해시태그를 구성하도록 세팅합니다.</p>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon"><i className="fa fa-solid fa-gears" /></div>
                    <h4>자동화 템플릿(프리셋) 관리</h4>
                    <p>한 번만 설정해두면, 이후 모든 게시물 등록 시 클릭 한 번으로 고품질 홍보글과 CTA가 자동 완성됩니다.</p>
                  </div>
                </div>
              </section> */}

              <section className="list-section-wrapper">
                <div className="filter-header">
                  <div className="filter-controls-row">
                    <div className="filter-input-wrap">
                      <TextInput
                        type="text"
                        id="search_q"
                        placeholder="설정 제목 검색"
                        value={q}
                        onChange={(e, value) => this.setState({ q: value })}
                        width="100%"
                        height="36px"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            this.setState({ page: 1 }, this.fetchListFromApi);
                          }
                        }}
                      />
                    </div>

                    <div className="filter-select-wrap">
                      <SelectBoxV2
                        id="languageSelect"
                        className="form-control"
                        pageWrapperName="common-page-wrapper"
                        width="100%"
                        height="36px"
                        padding="6px 30px 6px 10px"
                        list={LANGUAGE_OPTIONS}
                        optionTexttName="text"
                        optionValuetName="value"
                        selectedValue={language_code}
                        placeHolder="전체 언어"
                        onClickOption={this.handleSelectBox("language_code")}
                        tabIndex={0}
                      />
                    </div>

                    <div className="filter-select-wrap">
                      <SelectBoxV2
                        id="learningSelect"
                        className="form-control"
                        pageWrapperName="common-page-wrapper"
                        width="100%"
                        height="36px"
                        padding="6px 30px 6px 10px"
                        list={LEARNING_OPTIONS}
                        optionTexttName="text"
                        optionValuetName="value"
                        selectedValue={is_data_learning_on}
                        placeHolder="전체 학습 설정"
                        onClickOption={this.handleSelectBox("is_data_learning_on")}
                        tabIndex={0}
                      />
                    </div>

                    <div className="date-range-group">
                      <div className="filter-date-picker">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => this.setState({ startDate: date, page: 1 })}
                          selectsStart
                          startDate={startDate}
                          endDate={endDate}
                          maxDate={endDate || undefined}
                          dateFormat="yyyy.MM.dd"
                          locale={ko}
                          isClearable
                          placeholderText="시작일"
                          customInput={<input className="date-input" />}
                        />
                      </div>
                      <span style={{ color: "var(--text-muted)" }}>~</span>
                      <div className="filter-date-picker">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => this.setState({ endDate: date, page: 1 })}
                          selectsEnd
                          startDate={startDate}
                          endDate={endDate}
                          minDate={startDate || undefined}
                          dateFormat="yyyy.MM.dd"
                          locale={ko}
                          isClearable
                          placeholderText="종료일"
                          customInput={<input className="date-input" />}
                        />
                      </div>
                    </div>

                    <button
                      className="btn-apply"
                      type="button"
                      onClick={() => this.setState({ page: 1 }, this.fetchListFromApi)}
                    >
                      필터 적용
                    </button>
                  </div>

                  <div className="filter-chips-row">
                    <div className="chip-group">
                      <button type="button" className={"chip-btn" + (!dateType || dateType === "all" ? " active" : "")} onClick={() => this.setQuickRange("all")}>전체</button>
                      <button type="button" className={"chip-btn" + (dateType === "today" ? " active" : "")} onClick={() => this.setQuickRange("today")}>오늘</button>
                      <button type="button" className={"chip-btn" + (dateType === "week" ? " active" : "")} onClick={() => this.setQuickRange("week")}>이번 주</button>
                      <button type="button" className={"chip-btn" + (dateType === "month" ? " active" : "")} onClick={() => this.setQuickRange("month")}>이번 달</button>
                    </div>
                    <div className="total-count">총 <span>{this.fmtNumber(total)}</span>개</div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="robo-table">
                    <thead>
                      <tr>
                        <th style={{ width: "5%" }}>No.</th>
                        {this.renderSortHead("설정 제목", "icp.preset_title", "left", "14%")}
                        <th style={{ width: "10%" }}>업종</th>
                        <th style={{ width: "20%" }}>타겟</th>
                        <th style={{ width: "7%" }}>언어</th>
                        <th style={{ width: "8%" }}>브랜드 보이스</th>
                        <th style={{ width: "8%" }}>학습 설정</th>
                        <th style={{ width: "10%" }}>CTA 위치</th>
                        {this.renderSortHead("등록일", "icp.reg_date", "center", "8%")}
                        <th
                          style={{ width: "15%" }}
                          {...(tutorialListLoaded && rows.length === 0
                            ? { "data-instagram-tutorial": "copy-list-manage-empty" }
                            : {})}
                        >
                          관리
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.length === 0 ? (
                        <tr className="empty-row">
                          <td colSpan={10} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>
                            조건에 맞는 카피라이터 설정이 없습니다.
                          </td>
                        </tr>
                      ) : (
                        rows.map((row, index) => {
                          return (
                            <tr
                              key={row.id}
                              style={{ cursor: "pointer" }}
                              onClick={() => this.goDetailPage(row.id)}
                            >
                              <td data-label="No.">{this.getRowNo(index)}</td>
                              <td data-label="설정제목" className="text-left cell-title">{row.preset_title}</td>
                              <td data-label="업종">{row.industry}</td>
                              <td data-label="타겟" style={{ lineHeight: 1.4 }}>{row.target}</td>
                              <td data-label="언어">{this.getLanguageName(row.language_code)}</td>
                              <td data-label="브랜드 보이스">
                                <div className="badge-list">{this.renderVoiceBadges(row)}</div>
                              </td>
                              <td data-label="학습 설정">{this.renderLearningBadge(row.is_data_learning_on)}</td>
                              <td data-label="CTA 위치">{this.getCtaPositionText(row.call_to_action_position)}</td>
                              <td data-label="등록일">{row.reg_date_format || "-"}</td>
                              <td data-label="관리" onClick={(e) => e.stopPropagation()}>
                                <div className="copywriter-action-group">
                                  <button
                                    type="button"
                                    className="copywriter-table-run-btn"
                                    data-instagram-tutorial={index === 0 ? "copy-list-run" : undefined}
                                    onClick={(e) => this.openCopywriterRunModal(e, row.id)}
                                  >
                                    <CopywriterRunIcon />
                                    AI 카피라이터 실행
                                  </button>
                                  <button
                                    type="button"
                                    className="copywriter-duplicate-btn"
                                    data-instagram-tutorial={index === 0 ? "copy-list-duplicate" : undefined}
                                    disabled={this.state.duplicatingPresetSeq === row.id || this.state.deletingPresetSeq === row.id}
                                    onClick={(e) => this.duplicatePreset(e, row)}
                                  >
                                    <i className="fa fa-solid fa-copy" aria-hidden="true" />
                                    복제
                                  </button>
                                  <button
                                    type="button"
                                    className="copywriter-delete-btn"
                                    data-instagram-tutorial={index === 0 ? "copy-list-delete" : undefined}
                                    disabled={this.state.deletingPresetSeq === row.id || this.state.duplicatingPresetSeq === row.id}
                                    onClick={(e) => this.openDeleteConfirmDialog(e, row)}
                                  >
                                    <i className="fa fa-solid fa-trash" aria-hidden="true" />
                                    삭제
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="pagination-container">
                  <div />

                  <div className="page-numbers">
                    <button type="button" disabled={page <= 1} onClick={() => this.goPage(page - 1)}><i className="fa fa-solid fa-caret-left" /></button>
                    {Array.from({ length: Math.min(5, totalPages) }).map((_, i) => {
                      const half = Math.floor(5 / 2);
                      let start = Math.max(1, page - half);
                      let end = Math.min(totalPages, start + 4);
                      if (end - start < 4) start = Math.max(1, end - 4);
                      const p = start + i;
                      if (p > totalPages) return null;

                      return (
                        <button
                          type="button"
                          key={p}
                          className={p === page ? "active" : ""}
                          onClick={() => this.goPage(p)}
                        >
                          {p}
                        </button>
                      );
                    })}
                    <button type="button" disabled={page >= totalPages} onClick={() => this.goPage(page + 1)}><i className="fa fa-solid fa-caret-right" /></button>
                  </div>

                  <div className="page-size-selector">
                    <span>페이지당</span>
                    <SelectBoxV2
                      id="pageSizeSelect"
                      className="form-control"
                      pageWrapperName="common-page-wrapper"
                      width="120px"
                      height="36px"
                      padding="6px 30px 6px 10px"
                      list={pageSizes}
                      optionTexttName="text"
                      optionValuetName="value"
                      selectedValue={pageSize}
                      placeHolder="페이지 크기"
                      onClickOption={(text, value) => this.changePageSize({ target: { value } })}
                      tabIndex={0}
                    />
                  </div>
                </div>
              </section>
            </div>
          </main>
        </div>

        {this.state.copywriter_run_modal_show_state && (
          <RoboMDAICopywriterModal
            key={`copywriter-run-${this.state.copywriter_run_preset_seq || "default"}`}
            isOpen={this.state.copywriter_run_modal_show_state}
            onClose={this.closeCopywriterRunModal}
            presetMode={this.state.copywriter_run_preset_seq ? "FIXED" : "DEFAULT"}
            fixedPresetSeq={this.state.copywriter_run_preset_seq}
            historyEnabled={!this.state.copywriter_run_preset_seq}
            applyTargetLabel="콘텐츠 등록 화면"
            onContentRegister={this.handleCopywriterContentRegister}
            contentRegisterButtonLabel="선택 문구로 콘텐츠 등록"
          />
        )}

        {this.state.title_content_dialog_show_state && (
          <TitleContentDialogV2
            title={this.state.title_content_dialog_title}
            content={this.state.title_content_dialog_content}
            button_list={this.state.title_content_dialog_button_list}
            popup_close={this.closeDeleteConfirmDialog}
          />
        )}

        {this.state.warning_dialog_show_state && (
          <WarningDialog
            content={this.state.warning_dialog_content}
            button_list={this.state.warning_dialog_button_list}
            popup_close={this.closeWarningDialog}
            width_auto={this.state.warning_dialog_width_auto}
          />
        )}

        {this.state.save_dialog_show_state && (
          <SaveDialogV2
            content={this.state.save_dialog_content}
            button_list={this.state.save_dialog_button_list}
          />
        )}
      </>
    );
  }
}
